"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectHubManager = void 0;
const DirectHubConnection_1 = require("./DirectHubConnection");
const EventBus_1 = require("./EventBus");
const StellaBIO_1 = require("./StellaBIO");
const UnidentifiedDirectHubClient_1 = require("./UnidentifiedDirectHubClient");
class DirectHubManager {
    constructor(url) {
        this.events = new EventBus_1.EventBus();
        this.connection = new DirectHubConnection_1.DirectHubConnection(url);
        this._token = null;
        this._authorized = false;
        this._unidentifiedClients = {};
        this._clients = {};
        this._clientCount = 0;
        this.connection.onmessage = (msg) => this.onMessage(msg);
    }
    get token() {
        return this._token;
    }
    get authorized() {
        return this._authorized;
    }
    get unidentifiedClients() {
        return this._unidentifiedClients;
    }
    get clients() {
        return this._clients;
    }
    get clientCount() {
        return this._clientCount;
    }
    start() {
        this.connection.open().then(v => {
            if (v) {
                EventBus_1.EventBus.raise0(this.events, "connect");
            }
            else {
                EventBus_1.EventBus.raise0(this.events, "timeout");
                this.cleanup();
            }
        });
    }
    stop() {
        try {
            this.connection.close();
        }
        catch (ex) { }
        this.cleanup();
        EventBus_1.EventBus.raise0(this.events, "stop");
    }
    findClient(token) {
        var _a;
        return (_a = this._clients[token]) !== null && _a !== void 0 ? _a : null;
    }
    findStellaBIO(serialNumber) {
        for (const token in this._clients) {
            const client = this._clients[token];
            if (client instanceof StellaBIO_1.StellaBIO && client.serialNumber === serialNumber) {
                return client;
            }
        }
        return null;
    }
    onMessage(msg) {
        if (msg.type === "token") {
            this._token = msg.data.token;
        }
        else if (msg.type === "authed") {
            this._authorized = true;
        }
        else if (msg.type === "close") {
            EventBus_1.EventBus.raise0(this.events, "disconnect");
            this.cleanup();
        }
        else if (msg.type === "message") {
            if (msg.data.message.clients) {
                this.maintainClients(msg.data.message.clients);
            }
        }
    }
    maintainClients(clientsData) {
        var _a;
        for (const prop in this._unidentifiedClients) {
            if (clientsData.findIndex(v => v.token === prop) < 0) {
                this._clientCount--;
                const client = this._unidentifiedClients[prop];
                delete this._unidentifiedClients[prop];
                if (client.identifiedClient) {
                    delete this._clients[client.identifiedClient.id];
                }
                client.signal("disconnect");
                EventBus_1.EventBus.raise1(this.events, "clientLost", (_a = client.identifiedClient) !== null && _a !== void 0 ? _a : client);
            }
        }
        for (let i = 0; i < clientsData.length; i++) {
            const data = clientsData[i];
            if (!data.token) {
                console.warn("Received client data is missing a token");
                continue;
            }
            if (!this._unidentifiedClients[data.token]) {
                this._unidentifiedClients[data.token] = new UnidentifiedDirectHubClient_1.UnidentifiedDirectHubClient(data);
                this._clientCount++;
                EventBus_1.EventBus.raise1(this.events, "clientConnect", this._unidentifiedClients[data.token]);
            }
        }
        for (let i = 0; i < clientsData.length; i++) {
            const data = clientsData[i];
            const client = this._unidentifiedClients[data.token];
            if (!client) {
                console.log(clientsData, i, data.token, this._unidentifiedClients);
            }
            this.processClientData(client, clientsData[i]);
        }
    }
    tryIdentifyClient(client) {
        if (client.stale) {
            return;
        }
        if (client.data.sn && typeof client.data.sn === "string" && client.data.sn.length === 8) {
            if (this._clients[client.data.sn]) {
                const existingIdentifiedClient = this._clients[client.data.sn];
                for (const token in this._unidentifiedClients) {
                    const client = this._unidentifiedClients[token];
                    if (client.identifiedClient === existingIdentifiedClient) {
                        client.identifiedClient = null;
                        client.stale = true;
                    }
                }
                client.identifiedClient = existingIdentifiedClient;
                EventBus_1.EventBus.raise1(this.events, "clientReidentify", client);
                this.processClientData(client, client.data);
            }
            else {
                client.identifiedClient = this.createClient(client.data);
                this._clients[client.identifiedClient.id] = client.identifiedClient;
                EventBus_1.EventBus.raise1(this.events, "clientIdentify", client.identifiedClient);
            }
        }
    }
    processClientData(client, data) {
        var _a;
        if (client.updateData(data)) {
            if (client.identifiedClient) {
                EventBus_1.EventBus.raise1(this.events, "clientUpdate", (_a = client.identifiedClient) !== null && _a !== void 0 ? _a : client);
            }
            else {
                if (client.identifiedClient) {
                    EventBus_1.EventBus.raise1(this.events, "unidentifiedClientUpdate", client);
                }
            }
        }
        if (!client.identifiedClient) {
            this.tryIdentifyClient(client);
        }
    }
    createClient(data) {
        return new StellaBIO_1.StellaBIO(data);
    }
    cleanup() {
        for (const token in this._unidentifiedClients) {
            this._unidentifiedClients[token].signal("disconnect");
        }
        this._token = null;
        this._authorized = false;
        this._unidentifiedClients = {};
        this._clients = {};
        this._clientCount = 0;
    }
}
exports.DirectHubManager = DirectHubManager;
//# sourceMappingURL=DirectHubManager.js.map